export class Order{
    public Id : Number;
    public OrderNo : String;
    public RegistrationDate : Date;
    public ShipperId : Number = 0;
    public InvoiceNo : String;
    public AticleId : Number;
    public TypeId : Number;
    public Status : Number;
    public StatusText : String;
    public C_Name : String;
    public C_Address : String;
    public C_HouseNo : String;
    public C_Email : String;
    public C_PostalCodeId : Number = 0;
    public C_CityId : Number;
    public City : String;
    public Region : String;
    public Canton : String;
    public Country : String;
    public C_CantonId : Number;
    public C_CountryId : Number;
    public IsEU : Boolean;
    public D_DistributorId : Number;
    public D_DeliveryWeek : Number;
    public D_ShipDate : Date;
    public D_SheepWeek : Number;
    public D_LicensePlate : String;
    public D_T2No : String;
    public D_ReceiveDate : Date;
    public D_ReceiveWeek : Number;
    public D_Remark : String;
    public D_PlannedDate : Date;
    public D_ActualDate : Date;
    public D_ActualWeek : Number;
    public P_TotalAmount : Number = 0;
    public P_DepositeAmount : Number = 0;
    public P_OutstandingAmount : Number = 0;
    public P_PaidTo : Number;
    public P_PaidToType : Number;
    public F_CODCost : Number;
    public F_DeliverCost : Number = 0;
    public F_CustomeCost : Number = 0;
    public F_VAT : Number;
    public F_STRCost : Number = 0;
    public F_PFCost : Number = 0;
    public F_V_CHFCost : Number = 0;
    public F_V_EuroCHF : Number = 0;
    public F_V_DocumentCost : Number;
    public F_DistributorCost : Number = 0;
    public F_HantracoInvoiceNo : String;
    public F_PaymentDate : Date;
    public F_InvoiceValue : Number = 0;
    public F_CODCAmount : Number = 0;
    public F_VATAmount : Number = 0;
    public F_TransportInvoiceAmount : Number = 0;
    public F_CostVectorAmount : Number = 0;
    public F_TotalCost : Number = 0;
    public F_Revenue : Number = 0;
    public PostalCode : String = "";
    public P_ActualPaid : Number = 0;
    public P_ActualPaidRemark : String = "";
}

export class FieldsToBeDisabledByCountry{
    DE: any[] = ["DeliveryCosts", "InvoicenumberHantraco", "PaymentdatetoSSperLB"];
    AT: any[] = ["DeliveryCosts", "CostsSTR", "Distributorcosts", "InvoicenumberHantraco", "PaymentdatetoSSperLB"];
    CH: any[] = ["CashOnDeliveryCostper", "DeliveryCosts", "CustomsFees", "VATSwitzerlandPer", "CostsSTR", "CostsPF", "CostsCHF", "CostsEURCHF", "Documentcosts", "Distributorcosts", "InvoicenumberHantraco", "PaymentdatetoSSperLB"];
    NL: any[] = [];
}

export class DocumentDetail{
    public Id : Number = 0;
    public OrderId : Number;
    public DocumentName : String;
    public DocumentNo : String;
    public RegistrationDate : Date;
    public Description : String;
    public FilePath : String;
    public Files : any = [];
    public SendInApi : boolean = false;
}


export class OrderCustoms{
    Id: Number = 0;
    OrderId: Number = 0;
    HantracoGrossWeight: Number = 0;
    TotalInvoiceValue: Number = 0;
    VectorCustomValue: Number = 0;
    Factor: Number = 0;
    SumArticleGrossWeight: Number = 0;
    SumArticleNetWeight: Number = 0;
    SumArticleCustomsValue: Number = 0;
    SumNumberOfPackages: Number = 0;
    Articles: OrderCustomsArticle[] = [];
}

export class OrderCustomsArticle {
    Id: Number = 0;
    ArticleId: Number = 0;
    CustomOrderId: Number = 0;
    CHTarrifCode: string = "";
    ArticleGrossWeight: Number = 0;
    GrossPerNetPercentage: Number = 0;
    ArticleNetWeight: Number = 0;
    ArticleCustomValue: Number = 0;
    NumberOfPackages: Number = 0;
    PackagingId: string = "";
    Packaging: string = "";
    CurrencyId: Number = 0;
    Currency: string = "" ;
}

export class OrderRemark{
    Id: Number = 0;
    OrderId: Number = 0;
    D_Remark: String = undefined;
    S_IsRead: Number = undefined;
    S_Id: String = undefined;
    S_Name: String = undefined;
    S_ReadDate: any = undefined;
    S_Remark: String = undefined;
    D_IsRead: Number = undefined;
    D_Id: String = undefined;
    D_ReadDate: any = undefined;
    D_Name: String = undefined;
    R_Id: Number = undefined;
    UserType: Number =0;
    D_CreatedDate: String = undefined;
    D_ModifiedDate: string = undefined;
    D_CreatedBy: string = undefined;
    D_ModifiedBy: string = undefined;

    S_CreatedDate: String = undefined;
    S_ModifiedDate: string = undefined;
    S_CreatedBy: string = undefined;
    S_ModifiedBy: string = undefined;
}






// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/models/order.model.ts